import React from "react";
import { motion } from "framer-motion";
import { ArrowLeft } from "lucide-react";
import { spring, stagger, rise } from "../bits";

// Shared primitives for the in-app Management suite
export const DevScreen = ({ title, onBack, children, testid }) => (
  <div data-testid={testid}>
    <div className="flex items-center gap-3 mb-5">
      <motion.button whileTap={{ scale: 0.9 }} onClick={onBack} className="grid place-items-center h-10 w-10 rounded-full bg-white border border-brand/15 text-brand shrink-0" data-testid="dev-back" aria-label="back">
        <ArrowLeft className="h-5 w-5" />
      </motion.button>
      <h1 className="font-heading text-2xl font-medium text-brand-ink truncate">{title}</h1>
    </div>
    {children}
  </div>
);

export const DevCard = ({ children, className = "" }) => (
  <motion.div variants={rise} className={`rounded-2xl bg-white border border-brand/10 p-4 shadow-[0_6px_24px_rgba(134,77,99,0.07)] ${className}`}>
    {children}
  </motion.div>
);

export const DevList = ({ children }) => (
  <motion.div variants={stagger} initial="hidden" animate="show" className="space-y-2.5">{children}</motion.div>
);

export const Tgl = ({ on, onChange, testid }) => (
  <button type="button" onClick={() => onChange(!on)} className={`w-13 w-14 h-8 rounded-full p-1 transition-colors shrink-0 ${on ? "bg-brand" : "bg-brand/15"}`} data-testid={testid} aria-label="toggle">
    <motion.span layout transition={spring} className={`block h-6 w-6 rounded-full bg-white shadow ${on ? "ml-6" : "ml-0"}`} />
  </button>
);

export const Field = ({ label, children }) => (
  <div>
    {label && <p className="text-[11px] font-bold uppercase tracking-wide text-brand-ink/40 mb-1">{label}</p>}
    {children}
  </div>
);

export const DevInput = (props) => (
  <input
    {...props}
    className={`w-full h-11 rounded-xl border border-brand/20 bg-white px-3.5 text-sm text-brand-ink focus:outline-none focus:ring-2 focus:ring-brand/40 ${props.className || ""}`}
  />
);

export const DevTextarea = (props) => (
  <textarea
    {...props}
    className={`w-full rounded-xl border border-brand/20 bg-white px-3.5 py-2.5 text-sm text-brand-ink focus:outline-none focus:ring-2 focus:ring-brand/40 min-h-[80px] ${props.className || ""}`}
  />
);

export const SaveBtn = ({ onClick, busy, label, testid }) => (
  <motion.button
    whileTap={{ scale: 0.96 }}
    onClick={onClick}
    disabled={busy}
    className="rounded-full bg-brand text-brand-cream font-bold px-6 h-10 text-sm shadow disabled:opacity-40"
    data-testid={testid}
  >
    {label}
  </motion.button>
);
